"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSignInPath = void 0;
const buildSignInPath = (referrer) => `/signin/${referrer ? `?${new URLSearchParams({ referrer })}` : ""}`;
exports.buildSignInPath = buildSignInPath;
//# sourceMappingURL=signin.js.map